import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";

const container: CSSProperties = {};

const questionContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  fontFamily: fontFamilySans,
  fontSize: 14,
  fontWeight: 700,
  lineHeight: "28px",
  cursor: "pointer",
};

const icon: CSSProperties = {
  color: greys.slate,
  width: 20,
};

const baseAnswerContainer: CSSProperties = {
  fontFamily: fontFamilySans,
  fontSize: 14,
  lineHeight: "28px",
  overflow: "hidden",
  textAlign: "left",
  paddingLeft: 45,
  transition: `all 250ms ease-in-out`,
};

const answerContainerHidden: CSSProperties = {
  ...baseAnswerContainer,
  maxHeight: 0,
};

const answerContainerShown: CSSProperties = {
  ...baseAnswerContainer,
  maxHeight: 300,
};

const divider: CSSProperties = {
  margin: "15px 0",
};

export const styles = {
  container,
  icon,
  questionContainer,
  answerContainerHidden,
  answerContainerShown,
  divider,
};
